<template>
  <div>
    <apexchart :options="chartOptions" :series="series" type="pie" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: "pie"
        },
        labels: [],
        colors: ["#EE4D2D", "#03AC0E", "#E31E52", "#1890FF" ,"#000000"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        title: {
          text: "Total Scrape Semua Marketplace",
          style: {
            fontFamily: "CircularStd",
            fontSize: "20px",
            fontWeight: 500
          }
        },
        noData: {
          text: "Tidak ada data yang tersedia"
        }
      }
    };
  },
  async created() {
    await this.loadItems();
  },
  methods: {
    async loadItems() {
      await this.$store
        .dispatch("dashboard/getTotalScrapeMP")
        .then(response => {
          const { data } = response;
          data.forEach(element => {
            this.series.push(element.total);
            this.chartOptions.labels.push(element.marketplace);
          });
          if (this.series.every(item => item < 1)) {
            this.series = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.apexcharts-legend-text {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/totalScrapeMarketplace.vue